<div class="main-content">
  <div class="main-header">Cloud Load Configurations <div class="tooltip"><img src="./assets/Info.svg"
        alt="Image 1" /><span class="tooltiptext">Cloud Load feature allows us to select and load multiple
        configurations across modules sequentially in oracle cloud instance based on inbuilt dependencies , provides
        detailed error reporting and track configuration quality thus enabling project teams to concentrate on value add
        activities.</span></div>
    <span class="t-r" style="cursor: pointer;">
      <img style="vertical-align: middle;" src="./assets/Home.svg" [routerLink]="['']"
        [queryParams]="isTrainStopUrl? queryParams: ''" (click)="maskPage()" alt="back"></span>
  </div>

  <div class="" style="margin-top: 47px;">
    <div class="section ">
      <div class="content">
        <div class="b-m20" *ngIf="refresh">
          <div class="sub-text-600">Select Existing Batch Key in Process
            <div>This table will list extracted batches</div>
          </div>
          <div class="search-container">
            <div class="search-content">
              <input type="search" [(ngModel)]="searchText" name="searchText" autocomplete="off"
                (keyup.enter)="search(searchText)" (input)="searchOnInput($event.target.value, 'cloud')"
                placeholder="Search Batch Key" class="search" />
              <button (click)="search(searchText)" [disabled]="!searchText" mat-flat-button class="green-button"
                style="width:95px; margin-left: 24px;">Search</button>
            </div>
            <div class="refresh-container">
              <a style="cursor: hand; cursor:pointer" *ngIf="refresh === true && dataSourceCloud.filteredData.length > 0" (click)="onRefresh()"><img
                  src="./assets/Refresh.svg" alt="refresh"></a>
            </div>
          </div>

          <div *ngIf="loadToCloudData?.length>0">
            <div class="table-wrapper">
              <div class="table-container">
                <table style="width:100%">
                  <caption></caption>
                  <thead>
                    <th style="width:7%"> Select</th>
                    <th style="width:30%;padding-left: 8px !important;" scope="col"> Batch Key </th>
                    <th style="width:20%" *ngFor="let filter of filterSelectObj; let i=index;" scope="col">
                      <span> {{filter.name}} </span>
                      <select class="select-css" [(ngModel)]="filter.modelValue"
                        (change)="filterChange(filter,$event,i)">
                        <option *ngFor="let item of filter.options; let i=index" [value]="item">{{item}}</option>
                      </select>
                    </th>
                    <th style="width:14%" scope="col">
                      Date
                    </th>
                    <th style="width:10%" style="text-align: center;" scope="col">
                      Action
                    </th>
                  </thead>
                  <tr *ngIf="dataSourceCloud.filteredData.length == 0">
                    <td colspan="6"><span class="recordstext">No records found</span></td>
                  </tr>
                </table>
              </div>

              <div style="border: 5px solid rgba(208, 208, 206, 0.35);">
                <table mat-table
                  [dataSource]="tableData |  paginate: { itemsPerPage: size, currentPage: p, totalItems: dataSourceCloud.filteredData.length}"
                  style="text-align: left;width:100%" aria-hidden="true">
                  <caption></caption>
                  <ng-container matColumnDef="check_box">
                    <td mat-cell *matCellDef="let element" [ngClass]="'w-7 select-extract'" style="padding-left: 5px !important;">
                      <mat-radio-button (change)="selectedBatchKey=element"></mat-radio-button>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="batch_key">
                    <td mat-cell *matCellDef="let element" [ngClass]="'w-30'"> <a class="projectId"
                        (click)="onClickBatchKey(element)">{{element.batch_key}}</a>
                        <a class="details-info"><img title="Config Details" src="./assets/details_Info.svg" alt="Image 1" (click)="tasklistPopup(element.batch_key,element)"/></a></td>
                  </ng-container>

                  <ng-container matColumnDef="batch_status">
                    <td mat-cell *matCellDef="let element" [ngClass]="'w-20'"> {{element.batch_status}}</td>
                  </ng-container>

                  <ng-container matColumnDef="instance">
                    <td mat-cell *matCellDef="let element" [ngClass]="'w-20'"> {{element.instance}}</td>
                  </ng-container>

                  <ng-container matColumnDef="requested_date">
                    <td mat-cell *matCellDef="let element" [ngClass]="'w-15'"> {{element.requested_date | date
                      :'dd/MM/yyyy'}}</td>
                  </ng-container>

                  <ng-container matColumnDef="action">
                    <td mat-cell *matCellDef="let element" [ngClass]="'w-10'">
                      <img style="cursor: no-drop;"
                        *ngIf="element.batch_status != 'Cloud Load - Complete' && element.batch_status != 'Cloud Load - Error' 
                        && element.batch_status != 'Workbook Extraction - Complete' && element.batch_status != 'Workbook Extraction - Error' 
                        && element.batch_status != 'Cloud Extraction - Complete' && element.batch_status != 'Cloud Extraction - Error' "
                        src="./assets/Download-Disabled.svg" alt="download">
                      <img style="cursor: pointer;"
                        *ngIf="element.batch_status == 'Cloud Load - Complete' || element.batch_status == 'Cloud Load - Error' 
                        || element.batch_status == 'Workbook Extraction - Complete' || element.batch_status == 'Workbook Extraction - Error' 
                        || element.batch_status == 'Cloud Extraction - Complete' || element.batch_status == 'Cloud Extraction - Error' "
                        (click)="downloadFiles(element)" alt="download" src="./assets/Download.svg">
                    </td>
                  </ng-container>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>


              </div>
              <div class="pagenation-container" *ngIf="dataSourceCloud.filteredData.length>5">
                <table style="width:100%">
                  <caption></caption>
                  <thead>
                    <th style="width:100%" scope="row">
                      <pagination-controls (pageChange)="p = $event;paginate(p)"></pagination-controls>
                    </th>
                  </thead>
                </table>
              </div>
            </div>

            <div class="create-workbook" style="padding-bottom: 40px; border-bottom: 1px solid rgba(0,0,0,.12);display: flex;
                                    justify-content: flex-end;">
              <div>
                <button mat-flat-button [disabled]="!selectedBatchKey" class="green-button mt20 pull-right"
                  (click)="onClickBatchKey(selectedBatchKey)">
                  Load From Source</button>
              </div>
            </div>

            <!-- New Development -->
            <div class="sub-text-600" style="margin-top: 60px;">Cloud Load Batch Keys</div>
            <div class="search-container">
              <div class="search-content">
                <input type="search" name="searchText1" autocomplete="off" (keyup.enter)="searchForCloudWorkbook(searchText1)"
                  (input)="searchOnInput($event.target.value , 'cloudWorkBook')" [(ngModel)]="searchText1" placeholder="Search Batch Key"
                  class="search" />
                <button [disabled]="!searchText1" mat-flat-button class="green-button"
                  (click)="searchForCloudWorkbook(searchText1)" style="width:95px; margin-left: 24px;">Search</button>
              </div>
              <div class="refresh-container">
                <a style="cursor: hand; cursor:pointer" *ngIf="refresh === true && dataSourceCloudWorkBook.filteredData.length > 0" (click)="onRefresh()"><img
                    src="./assets/Refresh.svg" alt="refresh"></a>
              </div>
            </div>
            <div #scrollToMe>
              <div class="table-wrapper">
                <div class="table-container">
                  <table style="width:100%">
                    <caption></caption>
                    <thead>
                      <th style="width:30%" scope="col"> Batch Key </th>
                      <th style="width:23%" *ngFor="let filter of filterSelectObjForWorkbook; let i=index;" scope="col">
                        <span> {{filter.name}} </span>
                        <select class="select-css" [(ngModel)]="filter.modelValue"
                          (change)="filterChangeCWB(filter,$event,i)">
                          <option *ngFor="let item of filter.options; let i=index" [value]="item">{{item}}</option>
                        </select>
                      </th>
                      <th style="width:14%" scope="col">
                        Date
                      </th>
                      <th style="width:10%" style="text-align: center;" scope="col">
                        Action
                      </th>
                    </thead>
                    <tr *ngIf="dataSourceCloudWorkBook.filteredData.length == 0">
                      <td colspan="6"><span class="recordstext">No records found</span></td>
                    </tr>
                  </table>
                </div>
                <div style="border: 5px solid rgba(208, 208, 206, 0.35);">
                  <table  mat-table
                    [dataSource]="tableDataCloudWorkBook |  paginate: { id: 'portingTnPaginationId', itemsPerPage: size, currentPage: p1, totalItems: dataSourceCloudWorkBook.filteredData.length}"
                    style="text-align: left;width:100%" aria-hidden="true">
                    <caption></caption>
                    <ng-container matColumnDef="batch_key">
                      <td mat-cell *matCellDef="let element" [ngClass]="'w-30'"> <a class="projectId"
                          (click)="onClickBatchKey(element)">{{element.batch_key}}</a>
                          <a class="details-info"><img title="Config Details" src="./assets/details_Info.svg" alt="Image 1" (click)="tasklistPopup(element.batch_key,element)"/></a></td>
                    </ng-container>
  
                    <ng-container matColumnDef="batch_status">
                      <td mat-cell *matCellDef="let element" [ngClass]="'w-25'"> {{element.batch_status}}</td>
                    </ng-container>
  
                    <ng-container matColumnDef="instance">
                      <td mat-cell *matCellDef="let element" [ngClass]="'w-25'"> {{element.instance}}</td>
                    </ng-container>
  
                    <ng-container matColumnDef="requested_date">
                      <td mat-cell *matCellDef="let element" [ngClass]="'w-15'"> {{element.requested_date | date
                        :'dd/MM/yyyy'}}</td>
                    </ng-container>
  
                    <ng-container matColumnDef="action">
                      <td mat-cell *matCellDef="let element" [ngClass]="'w-10'">
                        <img style="cursor: no-drop;"
                          *ngIf="element.batch_status != 'Cloud Load - Complete' && element.batch_status != 'Cloud Load - Error'"
                          src="./assets/Download-Disabled.svg" alt="download">
                        <img style="cursor: pointer;"
                          *ngIf="element.batch_status == 'Cloud Load - Complete' || element.batch_status == 'Cloud Load - Error'"
                          (click)="downloadFiles(element)" alt="download" src="./assets/Download.svg">
                      </td>
                    </ng-container>
                    <tr mat-row *matRowDef="let row; columns: displayedCloudWorkBookColumns;"></tr>
                  </table>
                </div>
                <div class="pagenation-container" *ngIf="dataSourceCloudWorkBook.filteredData.length>5">
                  <table style="width:100%">
                    <caption></caption>
                    <thead>
                      <th style="width:100%" scope="row">
                        <pagination-controls id="portingTnPaginationId" (pageChange)="p1 = $event;paginateCWB(p1)"></pagination-controls>
                      </th>
                    </thead>
                  </table>
                </div>
                <button mat-flat-button [disabled]="loadNewBtnDisable" class="green-button mt20 pull-right" (click)="showLoadNewConfigPopUp()">
                  Load From File
                </button>
              </div>
            </div>


          </div>

          <div *ngIf="failedToFetchBatchKeys" class="empty-container">
            <div>
              <img src="./assets/Not Found.svg" alt="Not Found">
            </div>
            <div class="empty-container-content">
              <span>Something went wrong!</span>
              <button (click)="getLoadBatchkeys()" mat-flat-button class="green-button" style="margin-top: 15px;">Try
                Again</button>
            </div>
          </div>

          <div *ngIf="loadToCloudData?.length<1 && !failedToFetchBatchKeys" class="empty-container">
            <div>
              <img src="./assets/Not Found.svg" alt="Not Found">
            </div>
            <div class="empty-container-content">
              <span> No configuration found!</span>
              <button mat-flat-button style="margin-top: 15px;" class="green-button pull-right"
                (click)="onLoadNewConfig()"> <span>Load New Configuration</span> </button>
            </div>
          </div>

        </div>
        <div class="content1" *ngIf="failedToFetchBatchKeys">
          <div class="empty-container">
            <div>
              <img src="./assets/Not Found.svg" alt="Not Found">
            </div>
            <div class="empty-container-content">
              <span>Something went wrong!</span>
              <button (click)="getLoadBatchkeys()" mat-flat-button class="green-button" style="margin-top: 15px;">Try
                Again</button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
